class FacetFilters extends HTMLElement {
  constructor() {
    super();
    this.checkelements = this.querySelectorAll('input[type="checkbox"]');
    this.dropdowns = this.querySelectorAll("details.filter-dropdown");
  }
  connectedCallback() {
    this.checkelements.forEach((element) => {
      element.addEventListener("change", this.toggleCheckbox.bind(this));
    });
    this.dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("toggle", this.toggleDropdown.bind(this));
    });
    document.addEventListener("remove:filter", this.removeFilter.bind(this));
    let params = new URLSearchParams(window.location.search);
    params.set("filter.v.availability", 1);
    this._updateContent(params.toString(), {
      elements: [".productgrid--sidebar"],
    });
  }
  disconnectedCallback() {
    this.checkelements.forEach((element) => {
      element.removeEventListener("change", this.toggleCheckbox.bind(this));
    });
    this.dropdowns.forEach((dropdown) => {
      dropdown.removeEventListener("toggle", this.toggleDropdown.bind(this));
    });
    document.removeEventListener("remove:filter", this.removeFilter.bind(this));
  }
  toggleCheckbox(e) {
    let params = new URLSearchParams(window.location.search);
    const parent = e.currentTarget.closest("li");
    const value = e.currentTarget.value;
    const name = e.currentTarget.name;
    if (value === "1" && !e.currentTarget.checked) {
      params = this._removeParams(name, value, params);
      parent.classList.remove("filter-item--active");
    } else if (!e.currentTarget.checked) {
      params = this._removeParams(name, value, params);
      parent.classList.remove("filter-item--active");
    } else {
      params = this._addParams(name, value, params);
      parent.classList.add("filter-item--active");
    }
    params.set("section_id", this.dataset.sectionId);
    params.delete("page");
    this._updateContent(params.toString(), {
      elements: [".productgrid--sidebar", ".productgrid--wrapper"],
    });
  }
  _removeParams(name, val, params) {
    params.entries().forEach(([key, value]) => {
      if (key === name) {
        if (value === val) {
          params.delete(key, value);
        }
      }
    });
    return params;
  }
  _addParams(name, val, params) {
    if (params.get(name)) {
      params.append(name, val);
    } else {
      params.set(name, val);
    }
    return params;
  }
  _updateContent(newParams, { elements = [] } = {}) {
    fetch(`${window.location.pathname}?${newParams}`)
      .then((response) => response.text())
      .then((html) => {
        const domParser = new DOMParser();
        const doc = domParser.parseFromString(html, "text/html");
        if (elements.length > 0) {
          elements.forEach((element) => {
            const currentElement = document.querySelectorAll(element);
            if (currentElement.length > 0) {
              currentElement.forEach((elem, index) => {
                elem.innerHTML = doc.querySelectorAll(element)[index].innerHTML;
              });
            }
          });
        }
        const sanitizedParams = new URLSearchParams(newParams);
        sanitizedParams.delete("section_id");
        newParams = sanitizedParams.toString();
        window.history.pushState(
          null,
          "",
          `${window.location.pathname}${newParams.length > 0 ? "?" : ""}${newParams}`,
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }
  removeFilter(event) {
    event.preventDefault();
    this._updateContent(event.detail.filter, {
      elements: [".productgrid--sidebar", ".productgrid--wrapper"],
    });
  }
  toggleDropdown(event) {
    const open = event.target.open;
    const dropdown = event.target.closest("details.filter-dropdown");
    dropdown.classList.toggle("filter-dropdown--open", open);
  }
}

customElements.define("facet-filters", FacetFilters);

class ActiveFilters extends HTMLElement {
  constructor() {
    super();
    this.filters = this.querySelectorAll(".active-filter-item a");
  }
  connectedCallback() {
    this.filters.forEach((filter) => {
      filter.addEventListener("click", this.removeFilter.bind(this));
    });
  }
  removeFilter(event) {
    event.preventDefault();
    document.dispatchEvent(
      new CustomEvent("remove:filter", {
        detail: {
          filter: event.currentTarget.href.split("?")[1],
        },
      }),
    );
  }
  disconnectedCallback() {
    this.filters.forEach((filter) => {
      filter.removeEventListener("click", this.removeFilter.bind(this));
    });
  }
}

customElements.define("active-filters", ActiveFilters);

class facetTrigger extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector("button.utils-filter-button");
    this.filterDrawer = this.querySelector("filters-mobile#FilterDrawer");
  }
  connectedCallback() {
    this.trigger.addEventListener("click", this.toggleFilter.bind(this));
    document.addEventListener("close-filter-drawer", this.toggleFilter.bind(this));
  }
  toggleFilter(event) {
    event.preventDefault();
    this.trigger.classList.toggle("open");
    this.filterDrawer.classList.toggle("active");
    document.body.classList.toggle('scroll-lock');
  }
  disconnectedCallback() {
    this.trigger.removeEventListener("click", this.toggleFilter.bind(this));
    document.removeEventListener("close-filter-drawer", this.toggleFilter.bind(this));
  }
}

customElements.define("facet-trigger", facetTrigger);

class filtersMobile extends HTMLElement {
  constructor() {
    super();
    this.checkElements = this.querySelectorAll('input[type="checkbox"]');
    this.scrollState = this.scrollTop;
    this.accordionState = new Array(...this.querySelectorAll("details.filter-dropdown[open]")).map((accordion) => accordion.dataset.filterId);
  }
  connectedCallback() {
    this.attachEventListeners();
    let params = new URLSearchParams(window.location.search);
    params.set("filter.v.availability", 1);
    this._updateContent(params.toString(), {
      elements: [".filter-drawer__form"],
    });
    document.addEventListener("productgrid:sortby:updated", this.attachEventListeners.bind(this));
  }
  attachEventListeners() {
    const self = this;
    self.checkElements = self.querySelectorAll('input[type="checkbox"]');
    self.checkElements.forEach((checkElement) => {
      checkElement.addEventListener("change", self.toggleCheckbox.bind(self));
    });
  }
  toggleCheckbox(e) {
    let params = new URLSearchParams(window.location.search);
    const parent = e.currentTarget.closest("li");
    const value = e.currentTarget.value;
    const name = e.currentTarget.name;
    this.scrollState = this.scrollTop;
    this.accordionState = new Array(...this.querySelectorAll("details.filter-dropdown[open]")).map((accordion) => accordion.dataset.filterId);
    if (value === "1" && !e.currentTarget.checked) {
      params = this._removeParams(name, value, params);
      parent.classList.remove("filter-item--active");
    } else if (!e.currentTarget.checked) {
      params = this._removeParams(name, value, params);
      parent.classList.remove("filter-item--active");
    } else {
      params = this._addParams(name, value, params);
      parent.classList.add("filter-item--active");
    }
    params.set("section_id", this.dataset.sectionId);
    params.delete("page");
    this._updateContent(params.toString(), {
      elements: [".filter-drawer__form", ".productgrid--items", ".filter-drawer__footer", "#paginationContainer", "#mobile-filter-trigger"],
      scrollState: this.scrollState,
      accordionState: this.accordionState,
    });
  }
  _removeParams(name, val, params) {
    params.entries().forEach(([key, value]) => {
      if (key === name) {
        if (value === val) {
          params.delete(key, value);
        }
      }
    });
    return params;
  }
  _addParams(name, val, params) {
    if (params.get(name)) {
      params.append(name, val);
    } else {
      params.set(name, val);
    }
    params.set('filter.v.availability', 1);
    return params;
  }
  _updateContent(newParams, { elements = [] } = {}) {
    fetch(`${window.location.pathname}?${newParams}`)
      .then((response) => response.text())
      .then((html) => {
        const domParser = new DOMParser();
        const doc = domParser.parseFromString(html, "text/html");
        if (elements.length > 0) {  
          elements.forEach((element) => {
            const currentElement = document.querySelectorAll(element);
            if (currentElement.length > 0) {
              currentElement.forEach((elem, index) => {
                const newElement = doc.querySelectorAll(element)[index];
                if(!newElement) return;
                if (newElement.classList.contains('filter-drawer__form')) {
                  newElement.scrollTop = this.scrollState;
                  newElement.querySelectorAll("details.filter-dropdown").forEach((accordion) => {
                    if (accordion.dataset.filterId) {
                      accordion.open = this.accordionState.includes(accordion.dataset.filterId);
                    }
                  });
                }
                elem.innerHTML = newElement.innerHTML;
              });
            }
          });
        }
        this.checkElements = this.querySelectorAll('input[type="checkbox"]');
        this.checkElements.forEach((checkElement) => {
          checkElement.addEventListener("change", this.toggleCheckbox.bind(this));
        });
        const sanitizedParams = new URLSearchParams(newParams);
        sanitizedParams.delete("section_id");
        newParams = sanitizedParams.toString();
        window.history.pushState(
          null,
          "",
          `${window.location.pathname}${newParams.length > 0 ? "?" : ""}${newParams}`,
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }
  removeFilter(event) {
    event.preventDefault();
    this._updateContent(event.detail.filter, {
      elements: [".productgrid--sidebar", ".productgrid--wrapper"],
    });
  }
}

customElements.define("filters-mobile", filtersMobile);